import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../css/nav.css';
import { faBars, faPhone } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useRef, useState } from 'react';

export default function Nav() {
  const menuRef = useRef<HTMLDivElement | null>(null);
  const slideMenuRef = useRef<HTMLDivElement | null>(null);
  const [isMenuVisible, setMenuVisible] = useState(false);

  // Blokowanie scrolla na body tylko na mobile/tablet
  useEffect(() => {
    const unlockScroll = () => {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      if (menuRef.current) {
        if (slideMenuRef.current)
          slideMenuRef.current.style.display = 'none';
      }
    };

    if (isMenuVisible && window.innerWidth <= 700) {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      unlockScroll();
    }

    // Przy zmianie rozmiaru okna chowaj menu i odblokuj scroll
    const handleResize = () => {
      if (window.innerWidth > 700 && isMenuVisible) {
        setMenuVisible(false);
        unlockScroll();
      }
      // Przywróć scroll jeśli wysokość okna > 700px (np. obrót telefonu/tabletu)
      if (window.innerHeight > 700) {
        unlockScroll();
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      unlockScroll();
      window.removeEventListener('resize', handleResize);
    };
  }, [isMenuVisible]);

  // Pokazywanie navcontainer1 po scrollu
  useEffect(() => {
    const handleScroll = () => {
      if (menuRef.current) {
        const rect = menuRef.current.getBoundingClientRect();
        if (slideMenuRef.current) {
          if (rect.top < -50) {
            slideMenuRef.current.style.display = 'flex';
          } else {
            slideMenuRef.current.style.display = 'none';
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = (disable?: boolean) => {
    if (disable) {
      setMenuVisible(false);
    } else {
      setMenuVisible(oldValue => !oldValue);
    }
  };

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetId: string) => {
    e.preventDefault();
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      let scrollOffset = targetElement.getBoundingClientRect().top + window.scrollY;
      if (targetId === '#aboutme') {
        scrollOffset += 100;
      } else {
        scrollOffset -= 120;
      }
      window.scrollTo({
        top: scrollOffset,
        behavior: 'smooth',
      });
      toggleMenu(true);
    }
  };

  return (
    <>
      <div className='backHolder' style={{display: isMenuVisible ? 'block' : 'none'}} onClick={() => toggleMenu()}></div>
      <div className='navcontainer' ref={menuRef}>
        <div className='logo'>
          <img src="/images/logowhite3.png" alt="logo" />
        </div>
        <div className='submenu'>
          <a href="#aboutme" onClick={(e) => scrollToSection(e, '#aboutme')}>O mnie</a>
          <a href="#transformations" onClick={(e) => scrollToSection(e, '#transformations')}>Efekty</a>
          <a href="#packages" onClick={(e) => scrollToSection(e, '#packages')}>Cennik</a>
          <a href="#contact" onClick={(e) => scrollToSection(e, '#contact')}>Kontakt</a>
        </div>
        <div className='phone'>
          <a href="tel:536979286"><p><FontAwesomeIcon icon={faPhone}/> 536 979 286</p></a>
        </div>
      </div>
      <div className='navcontainer1' ref={slideMenuRef}>
        <div className='logo'>
          <img src="/images/logowhite3.png" alt="logo" />
        </div>
        <div className='menu'>
          <FontAwesomeIcon icon={faBars} onClick={() => toggleMenu()} />
        </div>
        <div className='submenu'>
          <a href="#aboutme" onClick={(e) => scrollToSection(e, '#aboutme')}>O mnie</a>
          <a href="#transformations" onClick={(e) => scrollToSection(e, '#transformations')}>Efekty</a>
          <a href="#packages" onClick={(e) => scrollToSection(e, '#packages')}>Cennik</a>
          <a href="#contact" onClick={(e) => scrollToSection(e, '#contact')}>Kontakt</a>
        </div>
        <div className='phone'>
          <a href="tel:536979286"><p><FontAwesomeIcon icon={faPhone}/> 536 979 286</p></a>
        </div>
      </div>
      <div className={`${isMenuVisible ? 'show' : 'hidden'}`}>
        <a href="#aboutme" onClick={(e) => scrollToSection(e, '#aboutme')}>O mnie</a>
        <a href="#transformations" onClick={(e) => scrollToSection(e, '#transformations')}>Efekty</a>
        <a href="#packages" onClick={(e) => scrollToSection(e, '#packages')}>Cennik</a>
        <a href="#contact" onClick={(e) => scrollToSection(e, '#contact')}>Kontakt</a>
      </div>
    </>
  );
}
